module.exports = __webpack_public_path__ + "static/fair-pay.3d83cc30.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/fair-pay.jpg
// module id = 1251
// module chunks = 4 5